import type { ReactNode } from "react";

export function PublicPageMain({ children }: { children: ReactNode }) {
  return <main>{children}</main>;
}
